import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LandingScreen, none } from './landingScreen';

interface LandingState {
  viewModel: LandingScreen.ViewModel;
}

const initialState: LandingState = {
  viewModel: none(''),
};

export const landingSlice = createSlice({
  name: 'landing',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<LandingScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = landingSlice.actions;

export default landingSlice.reducer;
